<script>

import Vue from "vue";

import Layout from "../../layouts/main";
import DatePicker from "vue2-datepicker";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";

import axios from "axios";
import { required } from "vuelidate/lib/validators";
import { requiredIf } from "vuelidate/lib/validators";

/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Posts List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, DatePicker },
  data() {
    return {
      gridData: {
        data: [],
        total: 0,
      },
      title: "Posts List",
      model: "Post",
      items: [
        {
          text: "Dashboard",
          href: "/dashboard"
        },
        {
          text: 'Posts List',
          active: true
        }
      ],
      submitted: false,
      theads: ["Posted By", "Room", "Post", "Subject", "Action"],
      isLoadingGetList: false,
      isLoadingPost: false,
      data: {
        title: null,
        description: null,
        subject_id: 0,
        room_id: 0,
        item_id: 0,
        year_id: null,
        date: new Date(),
        attachments: [],
        protected_files: [],
        is_announcement: false,
      },
      filter: {
        paginate_count: 10,
        page: 1,
      },
      token: null,
      itemList: [],
      subjectList: [],
      yearList: [],
      roomList: [],
      list_error_messages: [],
      file_error_messages: [],
      errors: {
        room_id: false,
        subject_id: false
      },
      showAdvancedInput: false,
      attachments: [],
      protected_files: [],
    };
  },
  validations: {
    data: {
      date: { required },
      description: { required },
      year_id: { required }
    },
  },
  async mounted(){
    this.token = await localStorage.getItem('authToken')

    this.getItemList();
    this.getSubjectList();
    this.getYearList();
    this.getRoomList();

    this.getPostDetails();
  },
  methods: {
    getPostDetails(){

      Vue.swal({
        icon: "info",
        title: "Loading ...",
        showConfirmButton: false,
        closeOnEsc: false,
        closeOnClickOutside: false,
      });

      let post_id = this.$route.params.id;

      axios.get(process.env.VUE_APP_API + '/post/' + post_id, {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      })
      .then(res => {
        let post = res.data.data;

        this.data.title = post.title;
        this.data.description = post.description;
        this.data.subject_id = post.subject ? post.subject.id : 0;
        this.data.room_id = post.room.id;
        this.data.item_id = post.item ? post.item.id : 0;
        this.data.year_id = post.year.id;
        this.data.is_announcement = post.is_announcement;
        this.data.date = new Date(post.date_string);

        this.attachments = post.attachments;
        this.protected_files = post.protected_files;

        if(this.$store.getters['auth/isAdmin']) {
          if(post.is_announcement){
            var index = this.roomList.findIndex(room => room.id == 'all');
            if(index == -1){
              this.roomList.push({
                id: 'all',
                name: 'All Rooms'
              })
            }
          }
        }

        Vue.swal.close();
      })
    },
    getItemList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/public/item')
      .then(res => {
        this.itemList = res.data.data;

        this.itemList.unshift({
          id: 0,
          name: 'Select one of the items'
        });
      })
    },
    getSubjectList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/public/subject')
      .then(res => {
        this.subjectList = res.data.data;

        this.subjectList.unshift({
          id: 0,
          name: 'Select one of the subjects'
        });
      })
    },
    getYearList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/public/year')
      .then(res => {
        this.yearList = res.data.data;
        
        this.yearList.forEach(year => {
          if(year.is_active){
            this.data.year_id = year.id;
          }
        })
      })
    },
    getRoomList(){
      //fetch data from API
      axios.get(process.env.VUE_APP_API + '/room/getIndex', {
        headers: {
          Authorization: 'Bearer ' + this.token
        }
      })
      .then(res => {
        this.roomList = res.data.data;

        this.roomList.unshift({
          id: 0,
          name: 'Select one of the rooms'
        });
      })
    },
    confirmationFormSubmit(){
      if(this.data.is_announcement && this.data.room_id !== 'all'){
        let room_name = this.roomList.find(room => room.id == this.data.room_id).name;
        Swal.fire({
          title: 'Are you sure?',
          text: "You are about to update ONLY "+ room_name +" and others will not be affected!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#34c38f',
          cancelButtonColor: '#f46a6a',
          confirmButtonText: 'Yes, update it!'
        }).then((result) => {
          if (result.isConfirmed) {
            this.formSubmit();
          }
        })
      } else {
        this.formSubmit();
      }
    },
    formSubmit(e){

      this.submitted = true;
      this.list_error_messages = [];
      this.file_error_messages = [];

      if(!this.data.room_id){
        this.errors.room_id = true;
      }

      if(!this.data.subject_id){
        this.errors.subject_id = true;
      }

      if(!this.data.item_id){
        this.errors.item_id = true;
      }

      this.$v.$touch();

      if(this.$v.$invalid || this.errors.room_id){
        return;
      }

      this.isLoadingPost = true;

      let formData = new FormData();
      formData.append('title', this.data.title)

      if(this.data.description){
        formData.append('description', this.data.description)
      }
      
      if(this.data.subject_id > 0){
        formData.append('subject_id', this.data.subject_id)
      }

      if(this.data.item_id > 0){
        formData.append('item_id', this.data.item_id)
      }
      
      formData.append('room_id', this.data.room_id)
      formData.append('year_id', this.data.year_id)
      formData.append('date', this.data.date)

      if(this.data.is_announcement){
        formData.append('is_announcement', this.data.is_announcement)
      }

      let max_size = 2 * 1024 * 1024; //2MB
      let max_size_string = '2MB';
      if(this.data.is_announcement){
        max_size = 20 * 1024 * 1024; //20MB
        max_size_string = '20MB';
      }

      for(let i = 0; i < this.data.attachments.length; i++){
        if(this.data.attachments[i].size > max_size){
          this.file_error_messages.push('File ' + this.data.attachments[i].name + ' is too large. Max. file size is ' + max_size_string);
        } else {
          formData.append('attachments[]', this.data.attachments[i])
        }
      }

      for(let i = 0; i < this.data.protected_files.length; i++){
        if(this.data.protected_files[i].size > max_size){
          this.file_error_messages.push('File ' + this.data.protected_files[i].name + ' is too large. Max. file size is ' + max_size_string);
        } else {
          formData.append('protected_files[]', this.data.protected_files[i])
        }
      }

      if(this.file_error_messages.length > 0){
        this.isLoadingPost = false;
        return;
      }

      formData.append('_method', 'PUT')

      let post_id = this.$route.params.id;

      axios.post(process.env.VUE_APP_API + '/post/' + post_id, formData, {
        headers: {
          Authorization: 'Bearer ' + this.token,
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(res => {
        console.log(res.data);
        Swal.fire("Success", "Post has been updated", "success");
        // this.$router.push({ name: 'Posts List' });
        this.$router.go(-1);
      })
      .catch(err => {
        if('response' in err){
          if('data' in err.response){
            if('message' in err.response.data){
              this.list_error_messages.push(err.response.data.message);
            }
          }
        }
      })
      .finally(() => {
        this.isLoadingPost = false;
      })
    },
    onClickGoBack(){
      this.$router.go(-1);
    },
    onChangeFileInput(e, data_type = 'attachments'){
      //validate max file size 2mb per each file
      let files = e.target.files;
      let max_size = 2 * 1024 * 1024; //2MB
      let max_size_string = '2MB';

      if(this.data.is_announcement){
        max_size = 20 * 1024 * 1024; //20MB
        max_size_string = '20MB';
      }

      this.file_error_messages = []

      if(this.data[data_type].length + files.length > 5){
        this.file_error_messages.push('You can only upload maximum 4 files');
        //reset input
        e.target.value = '';
        return;
      }
      
      for(let i = 0; i < files.length; i++){
        let size = files[i].size;
        if(size > max_size){
          this.file_error_messages.push('File ' + files[i].name + ' is too large. Max. file size is ' + max_size_string);
          continue;
        } else {
          this.data[data_type].push(files[i])
        }
      }
    },
    renderFileIcon(attachment){
      let filetype = attachment.name;
      
      if(filetype.includes('png') || filetype.includes('jpg') || filetype.includes('jpeg') || filetype.includes('gif') || filetype.includes('svg')){
        return 'bx bxs-file-image text-primary';
      } else if(filetype.includes('pdf')){
        return 'bx bxs-file-pdf text-danger';
      } else if(filetype.includes('word') || filetype.includes('doc') || filetype.includes('docx')){
        return 'bx bxs-file-doc text-primary';
      } else if(filetype.includes('excel') || filetype.includes('xls') || filetype.includes('xlsx')){
        return 'bx bxs-file-excel text-success';
      } else if(filetype.includes('powerpoint') || filetype.includes('ppt') || filetype.includes('pptx')){
        return 'bx bxs-file text-danger';
      } else {
        return 'bx bxs-file text-dark';
      }
    },
    onClickRemoveAttachment(attachment){
      console.log(attachment)

      if('id' in attachment){
        Vue.swal({
          icon: "info",
          title: "Loading ...",
          showConfirmButton: false,
          closeOnEsc: false,
          closeOnClickOutside: false,
        });
        
        axios.post(process.env.VUE_APP_API + '/post/' + this.$route.params.id + '/attachment/' + attachment.id, {
          _method: 'DELETE'
        }, {
          headers: {
            Authorization: 'Bearer ' + this.token
          }
        })
        .then(res => {
          Vue.swal.close();

          let index = this.attachments.findIndex(attach => attach.id == attachment.id);
          console.log('index ' + index)
          this.attachments.splice(index, 1);
        })
        .catch(err => {
          console.log(err)
        })
      } else {
        let index = this.data.attachments.findIndex(attach => attach.name == attachment.name);
        console.log('else '+ index)
        this.data.attachments.splice(index, 1);
        return;
      }
    },
    onClickRemoveProtectedFile(protected_file){
      console.log(protected_file)

      if('id' in protected_file){
        Vue.swal({
          icon: "info",
          title: "Loading ...",
          showConfirmButton: false,
          closeOnEsc: false,
          closeOnClickOutside: false,
        });
        
        axios.post(process.env.VUE_APP_API + '/post/' + this.$route.params.id + '/protected_file/' + protected_file.id, {
          _method: 'DELETE'
        }, {
          headers: {
            Authorization: 'Bearer ' + this.token
          }
        })
        .then(res => {
          Vue.swal.close();

          let index = this.protected_files.findIndex(file => file.id == protected_file.id);
          console.log('index ' + index)
          this.protected_files.splice(index, 1);
        })
        .catch(err => {
          console.log(err)
        })
      } else {
        let index = this.data.protected_files.findIndex(file => file.name == protected_file.name);
        console.log('else '+ index)
        this.data.protected_files.splice(index, 1);
        return;
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card plan-box">
          <div class="card-body">
            <div class="col-lg-10 col-12 text-center plan-btn mb-3">
              <a
                @click="showAdvancedInput = !showAdvancedInput"
                class="btn btn-primary btn-sm position-relative"
              >{{ showAdvancedInput ? 'Hide' : 'Show' }} Advanced Options</a>
            </div>

            <div class="col mt-2">
              <form class="needs-validation" @submit.prevent="confirmationFormSubmit">
                <div class="row">
                  <div class="col-lg-10 col-12 bg-light mb-2" v-if="showAdvancedInput">
                    <div class="mb-3 mt-2">
                      <label for="inputYear">Select Year <span class="text-danger small">*</span></label>
                      <select
                        id="inputYear"
                        v-model="data.year_id"
                        class="form-control">
                        <option :value="year.id" v-for="(year, index) in yearList" :key="`year_${index}`">{{year.name}}</option>
                      </select>
                      <div v-if="submitted && $v.data.year_id.$error" class="invalid-feedback">
                        <span v-if="!$v.data.year_id.required">Select Year.</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-10 col-12" v-if="$store.getters['auth/isAdmin']">
                    <div class="form-check form-checkbox-outline form-check-primary mb-3">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="inputAnnouncement"
                          v-model="data.is_announcement"
                          :disabled="true"
                        />
                        <label class="form-check-label" for="inputAnnouncement">
                          Tick this box if you want to make this post as an announcement
                        </label>
                        <div class="text-muted">
                          <small>Announcement can be posted for all rooms. Once you have selected all rooms, <span class="text-danger fw-bolder">you can not revert back!</span></small>
                        </div>
                      </div>
                  </div>
                  <div class="col-lg-5 col-12">
                    <div class="mb-3">
                      <label for="inputDate">Date <span class="text-danger small">*</span></label>
                      <date-picker 
                        v-model="data.date" 
                        :first-day-of-week="1" 
                        lang="en"
                        :disabled="data.is_announcement ? true : false"
                        :class="{
                          'is-invalid': submitted && $v.data.date.$error,
                        }"
                      >
                      </date-picker>
                      <div v-if="submitted && $v.data.date.$error" class="invalid-feedback">
                        <span v-if="!$v.data.date.required">Select Date of the {{ model }}</span>
                      </div>
                      <div v-if="data.is_announcement" class="text-muted small">
                        Date can not be changed when post is an Announcement
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-12">
                    <div class="mb-3">
                      <label for="inputRoom">Select Room <span class="text-danger small">*</span></label>
                      <select
                        id="inputRoom"
                        v-model="data.room_id"
                        class="form-control"
                        @change="errors.room_id = false"
                        :class="{
                          'is-invalid': submitted && errors.room_id,
                        }"
                      >
                        <option :value="room.id" v-for="(room, index) in roomList" :disabled="!room.id" :key="`room_${index}`">{{room.name}}</option>
                      </select>
                      <div v-if="submitted && errors.room_id" class="invalid-feedback">
                        <span v-if="errors.room_id">Select Room of the {{ model }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-12" v-if="!data.is_announcement">
                    <div class="mb-3">
                      <label for="inputSubject">Select Subject <span class="text-danger small">*</span></label>
                      <select
                        id="inputSubject"
                        v-model="data.subject_id"
                        @change="errors.subject_id = false"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && errors.subject_id,
                        }"
                      >
                        <option :value="subject.id" v-for="(subject, index) in subjectList" :disabled="!subject.id" :key="`subject_${index}`">{{subject.name}}</option>
                      </select>
                      <div v-if="submitted && errors.subject_id" class="invalid-feedback">
                        <span v-if="errors.subject_id">Select Subject of the {{ model }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5 col-12" v-if="!data.is_announcement">
                    <div class="mb-3">
                      <label for="inputItem">Select Item <span class="text-danger small">*</span></label>
                      <select
                        id="inputItem"
                        v-model="data.item_id"
                        @change="errors.item_id = false"
                        class="form-control"
                        :class="{
                          'is-invalid': submitted && errors.item_id,
                        }"
                      >
                        <option :value="item.id" v-for="(item, index) in itemList" :disabled="!item.id" :key="`item_${index}`">{{item.name}}</option>
                      </select>
                      <div v-if="submitted && errors.item_id" class="invalid-feedback">
                        <span v-if="errors.item_id">Select Item of the {{ model }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-lg-10 col-12 ml-lg-auto">
                    <div class="mb-3">
                      <label for="inputField1">Title <span class="text-danger small">*</span></label>
                      <input
                        id="inputField1"
                        v-model="data.title"
                        type="text"
                        class="form-control"
                        placeholder="Title of the post"
                        :class="{
                          'is-invalid': submitted && $v.data.title.$error,
                        }"
                      />
                      <div v-if="submitted && $v.data.title.$error" class="invalid-feedback">
                        <span v-if="!$v.data.title.required">Title is required.</span>
                      </div>
                    </div>
                  </div> -->
                  <div class="col-lg-10 col-12 ml-lg-auto">
                    <div class="mb-3">
                      <label for="inputDescription">Description <span class="text-danger small">*</span></label>
                      <textarea
                        id="inputDescription"
                        v-model="data.description"
                        class="form-control"
                        rows="6"
                        placeholder="Ex: To complete task from Page 20 to Page 30"
                        :class="{
                          'is-invalid': submitted && $v.data.description.$error,
                        }"
                      ></textarea>
                      <div v-if="submitted && $v.data.description.$error" class="invalid-feedback">
                        <span v-if="!$v.data.description.required">Note is required.</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-10 col-12 ml-lg-auto">
                    <div class="mb-3">
                      <label for="formAttachment" class="form-label">Attachment</label>
                      <input class="form-control" type="file" id="formAttachment" multiple @change="(e) => onChangeFileInput(e, 'attachments')" />
                      <div class="mt-1 text-muted small">Max. 4 files with maximum file size {{ data.is_announcement ? '20MB' : '2MB' }} each</div>
                      <div class="mt-1 text-muted small" v-if="data.is_announcement">Modifying attachment will also affect other announcements in selected date</div>
                    </div>
                    <div v-for="(attachment, index) in data.attachments" :key="`new_attachment_${index}`" class="mb-2">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="text-truncate">
                          <i :class="renderFileIcon(attachment)"></i> {{ attachment.name }}
                          <button type="button" class="btn btn-link btn-sm text-danger" @click="onClickRemoveAttachment(attachment)">Remove</button>
                        </div>
                      </div>
                    </div>
                    <div v-for="(attachment, index) in attachments" :key="`uploaded_attachment_${index}`" class="mb-2">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="text-truncate">
                          <i :class="renderFileIcon(attachment)"></i> {{ attachment.name }}
                          <button type="button" class="btn btn-link btn-sm text-danger" @click="onClickRemoveAttachment(attachment)">Remove</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-10 col-12 ml-lg-auto">
                    <div class="mb-3">
                      <label for="formProtectedFile" class="form-label">Protected Files</label>
                      <input class="form-control" type="file" id="formProtectedFile" multiple @change="(e) => onChangeFileInput(e, 'protected_files')" />
                      <div class="mt-1 text-muted small">Max. 4 files with maximum file size {{ data.is_announcement ? '20MB' : '2MB' }} each</div>
                      <div class="mt-1 text-muted small" v-if="data.is_announcement">Modifying attachment will also affect other announcements in selected date</div>
                    </div>
                    <div v-for="(protected_file, index) in data.protected_files" :key="`new_protected_file_${index}`" class="mb-2">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="text-truncate">
                          <i :class="renderFileIcon(protected_file)"></i> {{ protected_file.name }}
                          <button type="button" class="btn btn-link btn-sm text-danger" @click="onClickRemoveProtectedFile(protected_file)">Remove</button>
                        </div>
                      </div>
                    </div>
                    <div v-for="(protected_file, index) in protected_files" :key="`uploaded_protected_file_${index}`" class="mb-2">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="text-truncate">
                          <i :class="renderFileIcon(protected_file)"></i> {{ protected_file.name }}
                          <button type="button" class="btn btn-link btn-sm text-danger" @click="onClickRemoveProtectedFile(protected_file)">Remove</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <b-alert show variant="danger" v-for="(err, index) in file_error_messages" :key="`file_error_${index}`">
                      {{ err }}
                    </b-alert>
                  </div>
                </div>

                <div class="col mb-3">
                  <b-alert class="mb-1" show variant="danger" v-for="(err, index) in list_error_messages" :key="`list_error_${index}`">
                    {{ err }}
                  </b-alert>
                </div>

                <div class="col-12 d-flex mt-3">
                  <button :disabled="isLoadingPost" class="btn btn-primary me-4" type="submit">Submit</button>
                  <button type="button" :disabled="isLoadingPost" class="btn btn-light" @click="onClickGoBack()">Go Back</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>